// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Grid-module--bx--text-truncate--end---rVr+";
export var bxTextTruncateFront = "Grid-module--bx--text-truncate--front--mYgc+";
export var column = "Grid-module--column--FvUep";